import {
  NgModule
} from '@angular/core';
import {
  CommissionsComponent
} from './commissions.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  CommissionsService
} from './commissions.service';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb/breadcrumb.module';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {LabelModule} from '@progress/kendo-angular-label';

@NgModule({
  declarations: [
    CommissionsComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    LabelModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    MatExpansionModule,
    SharedCommonModule
  ],
  providers: [
    CommissionsService
  ],
  entryComponents: [
    ConfirmDialogComponent
  ],
})
export class CommissionsModule {
}
